import { graphql } from '@generated/gql';

export const UPDATE_ORGANIZATION_USER_LANGUAGE = graphql(/** GraphQL */ `
  mutation languageSelectionModalUpdateOrganizationUserProfile(
    $input: UpdateOrganizationUserProfileInput!
  ) {
    updateOrganizationUserProfile(input: $input) {
      organizationUser {
        id
        language
      }
    }
  }
`);
